const MFAOptions = {
  Disabled: {
    label: "Disabled",
    value: "DISABLED",
  },
  Email: {
    label: "Email",
    value: "EMAIL",
  },
  AUTHENTICATOR_APP: {
    label: "Authenticator App",
    value: "AUTHENTICATOR_APP",
  },
};

export default MFAOptions;
